module.exports = __webpack_public_path__ + "img/Refresh - Blue.fa839df7.png";